module.exports = __webpack_public_path__ + "img/Group 1073four.5743e511.png";